module.exports = __webpack_public_path__ + "static/img/2.544a8717.png";